function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;}\n\t.st1{fill:#66CEEF;}\n\t.st2{fill:#1A87C7;}\n\t.st3{fill:#BDEDF8;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M179.51,495.41c0.4-61.6,39.4-89.2,79.6-112.2l473.6-273.4c13.8-8.4,31.2-18.6,49.8-13.4 c4.4,1.4,16.2,8,34.4,18.8l6,3.6c0.2,0,0.2,0.2,0.4,0.4c0.6,0.2,1.2,0.4,1.6,0.6c12.6,7.4,19.8,22.2,19.8,42v364.2 c0,18.4-6.2,39.4-17.6,59c-11.4,19.6-26.2,35.4-42.2,44.6l-504.6,291c-10,5.6-19.4,8.6-28.4,8.6c-6.6,0-12.6-1.6-18-4.6 c-0.4-0.2-0.8-0.8-1.2-1c-0.2,0-0.4,0-0.6-0.2l-35-20.2c-15.2-10.2-17.8-29.8-17.8-40.8L179.51,495.41L179.51,495.41z"
}), React.createElement("path", {
  className: "st1",
  d: "M524.71,306.01c-6.2,3.6-11.8,13.2-11.8,20.6c0,1.8,0.4,2.8,0.8,3.6l1.4,0.8c0.2,0,0.4,0,0.6,0 c0.4,0,1-0.4,1.4-0.4c0.4-0.2,1-0.2,1.6-0.6c1.4-0.8,2.6-2,3.8-3.2c0.8-0.8,1.4-1.6,2.2-2.6c0.4-0.6,0.8-1,1.2-1.6 c0.8-1.2,1.6-2.6,2.2-4c0.4-0.6,0.6-1.4,0.8-2c0.2-0.6,0.6-1.4,0.8-2c0.4-1.6,0.8-3.2,0.8-4.8c0-0.6,0-1-0.2-1.4 c0-0.6-0.2-1.2-0.2-1.6c-0.2-0.8-0.6-1.4-1.2-1.8c-0.2,0-0.2-0.2-0.6-0.2C527.51,304.81,526.3,305.41,524.71,306.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M778.71,108.01c-2.2-0.6-4.6-1-7-1c-11.2,0-22.2,6.6-32.8,13.2l-5.8,3.4l-467.8,270 c-46.4,26.6-73.4,51.8-73.6,101.6v367c0.2,8.4,1.8,23.6,12,30.4l12.6,7.4c-0.2-0.8-0.2-1.8-0.4-2.6c-0.2-1-0.4-2-0.6-3 c-0.6-4.2-1-8.2-1.2-11.8l0,0v-367.2l0,0c0-1,0.2-2.2,0.2-3.4c0.2-3.6,0.4-7.2,0.8-11c3-19.4,11.2-38.8,23-54.8 c12.8-18.4,25.4-26.4,39.4-34l220.8-127l0,0l280-161.6c1-0.6,1.8-0.8,2.8-1.2c1.2-0.6,2.2-1,3.4-1.6c3-1.4,5.8-2.6,8.8-3.4 c0.6-0.2,1-0.4,1.6-0.6C787.7,112.41,781.11,108.61,778.71,108.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M197.11,903.01l35,20.2c0.2,0.2,0.4,0,0.6,0.2c-5.4-3.4-9.6-8.2-12.6-14.2l-19.8-11.4 c-11.4-7.4-14.6-22.8-14.8-35.4v-367.2c0.4-55.4,33-81.8,76.6-106.8l468-270.2c14.8-8.6,32.4-21.2,50.4-16c3.6,1,14.6,7.4,24.4,13 c6.6-0.2,12.6,1,18.2,3.8c-0.2,0-0.2-0.2-0.4-0.4l-6-3.6c-18.2-10.8-29.8-17.4-34.4-18.8c-18.6-5.2-35.8,5-49.8,13.4l-473.4,273.4 c-40.2,23-79.2,50.6-79.6,112.2v367.2C179.51,873.41,181.7,893.01,197.11,903.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M528.71,305.01L528.71,305.01c0.4,0.4,0.8,1,1,1.8C529.71,306.01,529.1,305.41,528.71,305.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M529.51,314.41c-0.2,0.6-0.4,1.4-0.8,2C528.9,316.01,529.1,315.41,529.51,314.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M784.3,120.61c-1.2,0.6-2.2,1-3.4,1.6C782.31,121.61,783.51,121.21,784.3,120.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M277.3,412.41c1.6-0.8,3-1.6,4.6-2.6c3.8-2,7.6-4,11.8-6.4l204.4-118l0,0L277.3,412.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M527.7,318.61c-0.6,1.4-1.4,2.8-2.2,4C526.5,321.21,527.31,319.81,527.7,318.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M530.1,309.61c0-0.4-0.2-0.8-0.2-1.2c0,0.4,0.2,0.8,0.2,1.4V309.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M216.1,900.21l-12.6-7.4c-10.2-6.8-11.8-22-12-30.4v-367c0.4-49.8,27.2-75,73.6-101.6l468-270.2l5.8-3.4 c10.8-6.6,21.6-13.2,32.8-13.2c2.2,0,4.6,0.4,7,1c2.2,0.6,9,4.4,16.2,8.4c-0.6,0.2-1,0.4-1.6,0.6c4-1.2,7.8-1.8,11.6-2 c-9.8-5.6-20.8-12-24.4-13c-18-5.2-35.6,7.4-50.4,16l-468,270.2c-43.6,25-76.4,51.4-76.6,106.8v367c0.2,12.8,3.4,28,14.8,35.4 l19.8,11.4c-1.8-3.6-3.2-7.4-4.2-11.8C215.91,898.41,215.91,899.01,216.1,900.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M524.3,324.21c-0.8,1-1.4,1.8-2.2,2.6C523.31,326.01,523.71,325.01,524.3,324.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M517.11,330.41c-0.6,0.2-1,0.4-1.4,0.4C516.11,331.01,516.3,330.61,517.11,330.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M215.31,894.21c-0.6-3.8-1.2-7.6-1.2-11.8l0,0C214.1,886.21,214.71,890.21,215.31,894.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M231.51,456.61c2.2-3.8,4.4-7.2,6.6-10.2c-11.8,16.2-20,35.6-23,54.8 C217.71,486.61,223.31,471.01,231.51,456.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M513.9,331.01c0.2,0.2,0.6,0,1,0l-1.4-0.8C513.71,330.41,513.71,331.01,513.9,331.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M214.1,515.41c0-1,0.2-2.2,0.2-3.4C214.1,513.01,214.1,514.21,214.1,515.41L214.1,515.41z"
}), React.createElement("path", {
  className: "st3",
  d: "M484.71,309.21c1.8-1.2,3.2-2.8,4.8-4.6l-10.4,6C480.31,311.01,482.11,311.01,484.71,309.21z"
}), React.createElement("path", {
  className: "st3",
  d: "M540.1,299.81c0.6,1,0.8,2.2,1.2,3.4c0.6,1.6,1,3,1,4.8c0,0.6,0.4,1,0.4,1.6c0,0.8-0.4,1.6-0.4,2.4 c-0.2,1.4-0.4,2.8-0.6,4.2c-0.4,1.6-0.8,3.2-1.4,4.8c-0.2,0.6-0.2,1.2-0.6,1.6c-0.6,1.2-1.2,2.6-1.8,3.8c-0.4,0.8-0.8,1.4-1.2,2.2 c-1.4,2.2-3,4.4-4.8,6.4l-0.2,0.2c-4.6,4.8-10.4,8.2-16.2,8.2c-0.2,0-0.4,0-0.6,0s-0.4-0.2-0.6-0.2c-0.8,0-1.6,0-2.4-0.2 c-0.6-0.2-1.2-0.4-1.8-0.6l-1-0.6c-0.4-0.2-1-0.2-1.2-0.4c-0.4-0.2-0.4-0.6-0.8-0.8l-34.2-19.4c-2-1.2-3.2-3.4-3-5.8l-169.8,98 c-4.4,2.4-8.4,4.6-12.2,6.6c-1.4,0.8-2.6,1.4-4,2.2l-8.8,5c-10.4,6.2-19.6,15.2-27.2,25.8c-2,2.8-3.8,5.8-5.8,9.2 c-10,17.6-15.8,36.4-15.8,52.8v367c0,3.6,0.4,7.2,0.8,10.4c0.2,1,0.6,1.8,0.8,2.6c0.4,2,1,4.2,1.8,5.8c0.6,1.6,1.6,3,2.4,4.2 c0.4,0.8,0.8,1.6,1.4,2.2c1,1.4,2.4,2.4,3.6,3.6c1,0.8,1.8,1.8,2.8,2.4c9,5,21,3.6,34-4L778.3,618c14.2-8.2,27.6-22.4,37.8-40.2 c10-17.6,15.8-36.4,15.8-52.8V161.6c0-15-4.8-26.2-13.6-31.2c-1-0.6-2-0.8-3-1.2c-1.6-0.6-3-1-4.6-1.2c-1.4-0.2-2.6-0.4-4-0.4 c-0.2,0-0.2,0-0.4,0c-3.2,0-6.6,0.6-10,1.6c-0.2,0-0.6,0.2-0.8,0.2c-3.4,1-6.8,2.6-10.2,4.6c-0.8,0.4-1.6,0.8-2.4,1.4l-261.6,151 l14,8.2C537.31,296.01,538.71,297.81,540.1,299.81z M805.3,206.01c2,1,3.2,3.2,3.2,5.2v343.4c0,2.2-1.2,4.2-3.2,5.4l-535.4,309.2 c-1,0.6-2,0.8-3,0.8s-2.2-0.2-3.2-0.8c-2-1.2-3-3.2-3-5.4v-343.4c0-2.2,1-4.2,3-5.4l535.6-309 C801.3,204.81,803.71,204.81,805.3,206.01z"
}), React.createElement("path", {
  className: "st3",
  d: "M492.71,318.61l8.2,4.6c1.2-9.6,7.2-19.8,15-25.6l-7.2-4.2l-1.8,1C505.31,302.81,500.31,312.81,492.71,318.61z "
}), React.createElement("path", {
  className: "st3",
  d: "M507.3,341.01c-3.2-2.2-5.2-6-6-10.4l-25.2-14.2c10.2,3.8,19.4-7.2,23.4-17.4l-10,5.8 c-1.6,1.8-3.2,3.4-4.8,4.6c-2.6,1.6-4.4,1.6-5.6,1.4l-9,5.2c-0.2,2.2,0.8,4.6,3,5.8L507.3,341.01z"
}), React.createElement("path", {
  className: "st3",
  d: "M237.3,911.41c-1.2-1.2-2.6-2.2-3.6-3.6C234.71,909.21,235.91,910.41,237.3,911.41z"
}), React.createElement("path", {
  className: "st3",
  d: "M275.31,427.81l8.8-5c-13.8,7.4-24.8,14.4-36,30.8C255.5,443.01,264.9,434.01,275.31,427.81z"
}), React.createElement("path", {
  className: "st3",
  d: "M536.5,328.41c-1.4,2.2-3,4.4-4.8,6.4C533.71,332.81,535.1,330.61,536.5,328.41z"
}), React.createElement("path", {
  className: "st3",
  d: "M539.71,322.41c0.2-0.6,0.2-1.2,0.6-1.6c-0.6,1.8-1.4,3.6-2.4,5.4C538.51,324.81,539.1,323.61,539.71,322.41z"
}), React.createElement("path", {
  className: "st3",
  d: "M806.5,127.41L806.5,127.41L806.5,127.41C806.7,127.41,806.5,127.41,806.5,127.41z"
}), React.createElement("path", {
  className: "st3",
  d: "M535.1,294.41c2,1.2,3.6,3.2,4.8,5.2C538.71,297.81,537.31,296.01,535.1,294.41z"
}), React.createElement("path", {
  className: "st3",
  d: "M535.1,294.41l-14-8.2l-6.2,3.6l7,4C526.7,292.21,531.3,292.41,535.1,294.41z"
}), React.createElement("path", {
  className: "st3",
  d: "M232.3,905.61c-0.8-1.4-1.8-2.6-2.4-4.2C230.31,902.81,231.51,904.21,232.3,905.61z"
}), React.createElement("path", {
  className: "st3",
  d: "M227.9,895.41c-0.2-1-0.6-1.8-0.8-2.6C227.3,893.81,227.71,894.41,227.9,895.41z"
}), React.createElement("path", {
  className: "st3",
  d: "M784.71,134.21l-1.8,1c0.8-0.4,1.6-0.8,2.4-1.4C785.1,134.21,784.91,134.21,784.71,134.21z"
}), React.createElement("path", {
  className: "st3",
  d: "M541.3,303.01c0.4,1.6,1,3,1,4.8C542.31,306.21,541.7,304.81,541.3,303.01z"
}), React.createElement("path", {
  className: "st3",
  d: "M542.31,311.81c-0.2,1.4-0.4,2.8-0.6,4.2C542.11,314.41,542.31,313.41,542.31,311.81z"
}), React.createElement("path", {
  className: "st3",
  d: "M810.91,127.81c1.4,0.2,3,0.8,4.6,1.2C813.9,128.61,812.51,128.01,810.91,127.81z"
}), React.createElement("path", {
  className: "st3",
  d: "M795.5,129.21c0.2,0,0.6-0.2,0.8-0.2C796.11,129.21,795.91,129.21,795.5,129.21z"
}), React.createElement("path", {
  className: "st3",
  d: "M515.3,343.41c6-0.2,11.6-3.4,16.2-8.4c-2.2,2.2-4.6,4.2-7,5.6C521.3,342.41,518.51,343.41,515.3,343.41z"
}), React.createElement("path", {
  className: "st3",
  d: "M510.31,342.41c0.6,0.4,1.2,0.6,1.8,0.6c0.6,0.2,1.4,0.2,2.2,0.2c-1.8,0-3.4-0.6-5-1.4L510.31,342.41z"
}), React.createElement("path", {
  className: "st3",
  d: "M475.91,316.01l25.2,14.2c-0.2-1.2-0.8-2.4-0.8-3.8c0-1.2,0.4-2.4,0.6-3.6l-8.2-4.6c7.6-5.8,12.6-15.8,14.2-24 l-7.4,4.4C495.5,309.21,486.1,319.81,475.91,316.01z"
}), React.createElement("path", {
  className: "st3",
  d: "M515.91,297.41c0.8-0.6,1.6-1.6,2.6-2c1.2-0.6,2.4-1.2,3.4-1.6l-7-4l-6.2,3.6L515.91,297.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M825.1,126.61c-0.2,0.4-0.6,0.4-0.8,0.6c8.6,6.6,13.8,18.2,13.8,34.2v364.2c0,18-6.2,38-16.8,55.8 c-10.2,17.8-24.4,33.4-40,42.4c-136,78.4-368.6,212.8-504.4,291.2c-14,8.2-26.8,9.2-36.6,5.2c-0.2,0.4,0,0.6-0.2,1 c-1,1.8-3.2,2.8-5,2.8c-0.8,0-1.6-0.4-2.6-0.6c0.4,0.2,0.8,0.8,1.2,1c5.4,3,11.4,4.6,18,4.6c8.8,0,18.4-2.8,28.4-8.6l504.6-291.2 c16-9.2,31-25,42.2-44.6c11.4-19.4,17.6-40.4,17.6-59v-364.2c0-19.6-7.2-34.6-19.8-42c-0.6-0.2-1.2-0.4-1.6-0.6 C825.3,120.61,826.3,124.01,825.1,126.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M215.31,894.21c0.2,1,0.4,2,0.6,3C215.5,896.41,215.31,895.21,215.31,894.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M215.31,501.01c-0.6,3.8-0.8,7.4-0.8,11C214.3,508.61,214.71,504.81,215.31,501.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M528.51,317.41c0.2-0.4,0.2-0.6,0.4-1c-0.2,0.6-0.6,1.4-0.8,2C527.9,318.41,528.31,318.01,528.51,317.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M515.1,331.01c0,0,0.2,0,0.4-0.2C515.3,331.01,515.1,331.01,515.1,331.01L515.1,331.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M517.11,330.41c1.6-0.6,3.4-1.8,5.4-3.8c-1.2,1.2-2.6,2.4-3.8,3.2C517.7,330.41,517.51,330.41,517.11,330.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M525.5,322.41c-0.4,0.6-0.8,1-1.2,1.6C524.91,323.61,525.1,323.01,525.5,322.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M530.1,309.81c0,1.6-0.4,3.2-0.8,4.8C530.1,313.01,530.1,311.21,530.1,309.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M793.31,117.21c-2.8,0.8-5.8,2.2-8.8,3.4C787.51,119.21,790.1,118.01,793.31,117.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M512.7,326.61c0-7.2,5.6-16.8,11.8-20.6c1.6-0.8,2.8-1.2,3.6-1.2c0.2,0,0.4,0,0.6,0.2c0,0,0-0.2-0.2-0.2l-7-4 c0,0,0,0-0.2,0c-8.2,4.6-14.6,16-14.8,25.6l6.8,3.8C513.31,329.61,512.7,328.61,512.7,326.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M529.91,306.81c0.2,0.4,0.2,1,0.2,1.6C530.1,308.01,530.1,307.41,529.91,306.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M498.5,285.01c1.4-0.8,3-1,4.6-0.6c0.4-1.4,1.4-2.8,2.8-3.6l265-153c3.4-2,6.8-4,10.4-5.8 c-1,0.4-1.8,0.8-2.8,1.2L498.5,285.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M238.31,446.21c8.6-11.8,19.2-22,30.8-29.2l8.4-4.8C263.5,419.81,250.91,428.01,238.31,446.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M491.51,296.21l-215.4,123.8c6.4-3.6,13.2-7.2,21-11.6C344.3,381.21,416.51,339.61,491.51,296.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M819.71,124.01c-2.2-0.8-4.2-1.6-6.2-2c2.8,0.6,5.6,1.6,8,3c1,0.6,2,1.6,3,2.4c0.2-0.2,0.6-0.4,0.8-0.6 c1.4-2.8,0.4-6-2.2-7.6c-5.4-2.8-11.6-4-18.2-3.8C811.11,119.01,816.7,122.21,819.71,124.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M243.5,449.21c-14.2,19.4-23,43.6-23.2,66.2c0-18,6.2-38,16.8-55.8C239.1,455.61,241.51,452.41,243.5,449.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M240.31,921.41c0.2-0.2,0-0.6,0.2-1c-1.2-0.4-2.4-0.6-3.4-1.2c-1.4-0.8-2.6-2-3.8-3c0.6,0.6,1.2,1.4,1.8,1.8 l-15.2-8.8c3,6,7.4,10.8,12.6,14.2c0.8,0.4,1.6,0.6,2.6,0.6C237.11,924.01,239.1,923.01,240.31,921.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M793.71,123.61c3.2-1,6.4-1.8,9.4-2C800.1,121.61,796.7,122.21,793.71,123.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M803.71,121.21c3-0.2,5.8,0,8.4,0.4C809.51,121.01,806.5,121.01,803.71,121.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M773.71,133.41l-265,153l0,0c111-64,224.4-129.6,270.6-156.2C777.51,131.01,775.5,132.41,773.71,133.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M535.3,304.01c-0.8-1.8-1.8-3.2-3.4-4.2l0,0C533.71,301.01,534.71,302.41,535.3,304.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M221.51,893.61c-0.6-3.4-1-7-1-11C220.31,886.41,220.91,890.01,221.51,893.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M782.51,128.41c3.2-1.8,6.2-3.2,9.2-4.2C788.71,125.41,785.5,126.61,782.51,128.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M527.9,329.61c-0.6,0.8-1.4,1.4-2.2,2.2C526.5,331.01,527.51,330.41,527.9,329.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M535.1,316.61c-0.4,1.2-1,2.6-1.6,3.8C534.1,319.21,534.91,318.01,535.1,316.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M512.11,336.61l-1.6-1C510.91,336.01,511.51,336.21,512.11,336.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M521.3,335.41c0.2-0.2,0.4-0.4,0.6-0.6c-0.4,0.4-1,0.6-1.4,0.8C521.11,335.41,521.3,335.41,521.3,335.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M516.7,336.81c-0.8,0.2-1.6,0.2-2.4,0.2C515.1,337.21,516.11,337.21,516.7,336.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M532.51,323.01c-0.8,1.4-1.6,2.6-2.6,4C530.91,325.61,531.7,324.41,532.51,323.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M228.91,911.41c-0.6-0.8-1.2-1.8-1.8-2.8C227.3,909.61,227.9,910.41,228.91,911.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M224.1,903.61c-0.6-1.6-1.2-3.4-1.6-5C222.9,900.21,223.5,901.61,224.1,903.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M233.31,916.21c-1.6-1.4-3.2-2.8-4.6-4.6c-0.6-1-1.2-1.8-1.8-2.8c-1-1.6-2-3.4-2.8-5.2c-0.6-1.6-1.2-3.4-1.6-5 s-1-3-1.2-4.8c-0.6-3.6-1-7.2-1-11v-367.2c0.2-22.6,9-46.8,23.2-66.2c10.4-15,20.8-22.4,32.4-29.2l215.4-123.8 c5.8-3.4,11.6-6.6,17.4-10l0,0l265-153c1.8-1,3.8-2.2,5.6-3.2c0.6-0.4,1.4-0.8,2.2-1.2c0.4-0.2,0.8-0.4,1.2-0.6c3-1.6,6-3,9.2-4.2 c0.6-0.2,1.4-0.6,2-0.8c3-1,6.2-1.8,9.4-2c0.2,0,0.4,0,0.8,0c2.8-0.2,5.6-0.2,8.4,0.4c0.4,0,0.6,0,1,0.2c2,0.4,4,1,6.2,2 c-2.8-1.6-8.6-5-14.8-8.6c-3.8,0.2-7.6,0.8-11.6,2c-3,1-6,2.2-8.8,3.4c-1.2,0.6-2.2,1-3.4,1.6c-3.6,1.8-7,3.8-10.4,5.8l-265,153 c-1.4,0.8-2.4,2-2.8,3.6c-1.6-0.4-3.2-0.2-4.6,0.6l-204.4,118c-4.2,2.4-8,4.4-11.8,6.4c-1.6,0.8-3,1.6-4.6,2.6l-8.4,4.8 c-11.8,7-22.2,17.2-30.8,29.2c-2.2,3.2-4.4,6.6-6.6,10.2c-8.4,14.6-14,30-16.4,44.6c-0.6,3.6-0.8,7.4-0.8,11c0,1-0.2,2.2-0.2,3.4 v367c0,4.2,0.4,8.2,1.2,11.8c0.2,1,0.4,2,0.6,3c1,4.4,2.4,8.2,4.2,11.8l15.2,8.8C234.3,917.61,234.1,916.61,233.31,916.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M510.31,335.41l1.6,1c0.8,0.4,1.6,0.4,2.4,0.4s1.6,0,2.4-0.2c1.2-0.2,2.4-0.6,3.8-1.4c0.4-0.2,1-0.6,1.4-0.8 c1.4-0.8,2.6-1.8,3.8-3c0.8-0.8,1.4-1.4,2.2-2.2c0.6-0.8,1.2-1.6,1.8-2.4c1-1.2,1.8-2.6,2.6-4c0.4-1,0.8-1.8,1.2-2.8 c0.6-1.2,1.2-2.4,1.6-3.8c0.6-2.4,1.2-4.8,1.2-7.2c0-2.2-0.4-4-1-5.6c-0.8-1.6-1.8-3-3.2-4l0,0c-2.6-1.4-6.4-1.2-10.4,1l7,4 c0,0,0,0.2,0.2,0.2h0.2c0.4,0.2,0.8,0.8,1,1.8c0.2,0.4,0.2,1,0.2,1.6c0,0.4,0.2,0.6,0.2,1.2v0.2c0,1.6-0.4,3.2-0.8,4.8 c-0.2,0.6-0.4,1.4-0.8,2c-0.2,0.4-0.2,0.6-0.4,1s-0.4,0.6-0.6,1c-0.6,1.4-1.4,2.6-2.2,4c-0.4,0.6-0.8,1-1.2,1.6 c-0.8,1-1.4,1.8-2.2,2.6c-1.8,2-3.8,3.2-5.4,3.8c-0.6,0.2-1,0.4-1.4,0.4c0,0-0.2,0.2-0.4,0.2l-0.2-0.2c-0.4,0-0.8,0-1,0 c-0.2-0.2-0.4-0.4-0.4-0.8l-6.8-3.8v0.2C506.51,331.01,508.31,334.01,510.31,335.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M233.5,907.81c-0.6-0.6-1-1.6-1.4-2.2C232.71,906.41,232.9,907.41,233.5,907.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M229.71,901.41c-0.8-1.8-1.2-3.8-1.8-5.8C228.5,897.61,229.1,899.81,229.71,901.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M785.1,134.01c3.4-2,7-3.6,10.2-4.6C792.31,130.41,788.71,132.21,785.1,134.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M777.51,138.41l-256.4,148l0,0l261.8-151.2C781.11,136.01,779.1,137.41,777.51,138.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M796.3,129.01c3.6-1,7-1.6,10-1.6C802.9,127.41,799.71,128.01,796.3,129.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M817.31,129.61c-0.6-0.2-1.2-0.4-1.8-0.6c1,0.4,2.2,0.6,3,1.2c8.6,5,13.6,16.2,13.6,31.2v364.2 c0,16.4-5.8,35.2-15.8,52.8c-10.2,17.8-23.6,32-37.8,40.2l-504.6,291.4c-13,7.6-25,9-34,4c-1-0.6-1.8-1.6-2.8-2.4 c0.6,0.4,1,1,1.6,1.6c2.4,1.8,2.8,4.8,1.6,7.4c10,4.2,22.6,3,36.6-5.2c136-78.4,368.6-212.8,504.4-291.2c15.6-9,29.8-24.6,40-42.4 c10.4-17.8,16.8-37.8,16.8-55.8v-364.4c0-16.2-5.2-27.8-13.8-34.2C822.7,129.61,819.91,130.61,817.31,129.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M507.71,341.61c0.4,0.2,0.8,0.2,1.2,0.4l-2-1.2C507.3,341.01,507.71,341.61,507.71,341.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M514.91,343.61c0.2,0,0.4,0,0.6,0c-0.4,0-0.8,0-1,0C514.3,343.41,514.71,343.61,514.91,343.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M531.5,334.81l0.2-0.2C531.5,334.81,531.5,334.81,531.5,334.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M300.31,414.01l169.8-98l0,0l-186,107c1.2-0.8,2.6-1.4,4-2.2C291.7,418.61,295.91,416.21,300.31,414.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M247.9,453.61c-13.2,18-21.4,40.6-21.6,62c0-16.4,5.8-35.2,15.8-52.8C244.1,459.21,245.91,456.21,247.9,453.61 z"
}), React.createElement("path", {
  className: "st2",
  d: "M806.7,127.41c1.4,0,2.8,0.2,4,0.4C809.71,127.41,808.31,127.41,806.7,127.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M540.1,299.81c0.6,1,0.8,2.2,1.2,3.4C540.91,301.81,540.5,300.61,540.1,299.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M537.7,326.21c-0.4,0.8-0.8,1.4-1.2,2.2C537.11,327.81,537.51,326.81,537.7,326.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M542.51,309.61c0-0.6-0.2-1-0.4-1.6c0,1.2,0,2.6,0,4C542.51,311.01,542.51,310.41,542.51,309.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M541.5,316.01c-0.4,1.6-0.8,3.2-1.4,4.8C540.91,319.21,541.3,317.81,541.5,316.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M227.3,892.81c-0.6-3.2-0.8-6.6-0.8-10.4C226.51,886.41,226.7,889.81,227.3,892.81z"
}), React.createElement("polygon", {
  className: "st2",
  points: "489.51,304.41 478.91,310.61 479.1,310.61 489.51,304.81  "
}), React.createElement("path", {
  className: "st2",
  d: "M500.91,323.01l5.8,3.2c0.2-9.4,6.6-20.8,14.8-25.6c0,0,0,0,0.2,0l-5.6-3.2 C507.9,303.41,502.3,313.61,500.91,323.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M507.3,292.81c0,0.6-0.4,1.2-0.4,1.8l1.8-1L507.3,292.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M238.91,913.01c-0.6-0.4-1-1-1.6-1.6c-1.2-1-2.6-2.2-3.6-3.6c-0.6-0.6-1-1.6-1.4-2.2c-0.8-1.4-1.8-2.6-2.4-4.2 c-0.8-1.8-1.2-3.8-1.8-5.8c-0.2-1-0.6-1.8-0.8-2.6c-0.6-3.2-0.8-6.6-0.8-10.4v-367.2c0.2-21.4,8.4-44,21.6-62 c11.4-16.6,22.4-23.4,36-30.8l186-107l0,0l9-5.2h-0.2l10.6-6l0,0l10-5.8c1.2-3,1.8-5.8,2-8.2l-10,5.8c-75,43.2-147,85-194.4,112.2 c-7.6,4.4-14.4,8-21,11.6l-3.8,2.2c-10.8,6.6-20.6,16-28.6,27c-2.2,3.2-4.4,6.4-6.6,10.2c-10.4,17.8-16.8,37.8-16.8,55.8v367 c0,4,0.4,7.6,1,11c0.2,1.6,0.8,3.2,1.2,4.8c0.4,1.8,1,3.4,1.6,5c0.8,1.8,1.8,3.6,2.8,5.2c0.6,1,1.2,2,1.8,2.8 c1.2,1.6,2.8,3.2,4.6,4.6c1.2,1,2.4,2.2,3.8,3c1,0.6,2.2,0.8,3.4,1.2C241.51,917.81,240.91,914.81,238.91,913.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M535.3,304.01c1.6,3.6,1.4,8,0,12.6c-0.4,1.2-1,2.6-1.6,3.8c-0.4,1-0.8,1.8-1.2,2.8c-0.8,1.4-1.6,2.6-2.6,4 c-0.6,0.8-1.2,1.6-1.8,2.4s-1.4,1.4-2.2,2.2c-1.2,1.2-2.4,2.2-3.8,3c-0.2,0.2-0.4,0.4-0.6,0.6s-0.6,0.2-0.8,0.2 c-1.2,0.6-2.6,1-3.8,1.4c-0.8,0.2-1.6,0.2-2.4,0.2c-0.4,0-1,0.2-1.4,0.2l-1-0.6c-0.6-0.2-1.2-0.6-1.6-1l-9.2-5.2 c0.8,4.4,2.8,8.2,6,10.4l2,1.2c1.6,0.8,3.2,1.2,5,1.4c0.4,0,0.8,0,1,0c3-0.2,6-1,9.2-2.8c2.6-1.4,4.8-3.4,7-5.6l0.2-0.2 c1.8-2,3.4-4.2,4.8-6.4c0.4-0.6,0.8-1.4,1.2-2.2c1-1.8,1.6-3.6,2.4-5.4c0.6-1.6,1-3.2,1.4-4.8c0.4-1.4,0.6-2.8,0.6-4.2 c0.2-1.4,0.2-2.6,0-4c-0.2-1.8-0.6-3.2-1-4.8c-0.4-1.2-0.6-2.4-1.2-3.4c-1.2-2.2-2.8-4-4.8-5.2c-3.8-2.2-8.4-2.2-13.2-0.6l10,5.8 C533.51,300.61,534.71,302.21,535.3,304.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M803.71,121.21c-0.2,0-0.4,0-0.8,0c-3,0.2-6.2,1-9.4,2c-0.6,0.2-1.4,0.4-2,0.8c-3,1-6,2.4-9.2,4.2 c-1,0.6-2.2,1.2-3.2,1.8c-46.2,26.6-159.6,92.2-270.6,156.2l6.2,3.6l6.2-3.6l0,0l256.4-148c1.8-1,3.6-2.2,5.4-3l1.8-1 c0.2-0.2,0.4-0.2,0.8-0.4c3.4-1.8,6.8-3.4,10.2-4.6c0.2,0,0.6-0.2,0.8-0.2c3.4-1,6.6-1.6,10-1.6h0.2c0,0,0,0,0.2,0 c1.4,0,2.8,0.2,4,0.4c1.6,0.2,3,0.6,4.6,1.2c0.6,0.2,1.2,0.4,1.8,0.6c2.8,1.2,5.6,0,7.2-2.2c-1-0.8-1.8-1.8-3-2.4 c-2.4-1.4-5.2-2.4-8-3c-0.4,0-0.6,0-1-0.2C809.71,121.21,806.7,121.01,803.71,121.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M512.9,337.21c0.4,0,1-0.2,1.4-0.2c-0.8,0-1.8-0.2-2.4-0.4L512.9,337.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M532.11,299.81l-10-5.8c-1.2,0.4-2.4,0.8-3.4,1.6c-1,0.6-1.6,1.4-2.6,2l5.6,3.2 C525.5,298.61,529.1,298.41,532.11,299.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M533.71,320.41c-0.4,1-0.8,1.8-1.2,2.8C532.9,322.41,533.31,321.21,533.71,320.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M222.71,898.41c-0.4-1.6-1-3.2-1.2-4.8C221.51,895.21,222.11,896.61,222.71,898.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M499.51,299.01l7.4-4.4c0.2-0.6,0.4-1.2,0.4-1.8l1.4,0.8l6.2-3.6l-6.2-3.6c-5.8,3.4-11.6,6.6-17.4,10l10-5.8 C501.51,293.01,500.5,296.01,499.51,299.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M506.51,326.61L506.51,326.61l-5.8-3.4c-0.2,1.2-0.6,2.4-0.6,3.6c0,1.4,0.6,2.4,0.8,3.8l9.2,5.2 C508.31,334.01,506.51,331.01,506.51,326.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M535.1,316.61c1.4-4.6,1.6-9.2,0-12.6c0.6,1.6,1,3.4,1,5.6C536.3,311.61,536.11,314.21,535.1,316.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M520.5,335.41c-1.4,0.6-2.6,1-3.8,1.4C518.31,336.61,519.51,336.01,520.5,335.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M530.1,327.21c-0.6,0.8-1.2,1.8-1.8,2.4C528.71,328.61,529.1,328.01,530.1,327.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M525.91,331.61c-1.2,1.2-2.4,2.2-3.8,3C523.51,334.01,524.71,333.01,525.91,331.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M813.51,121.81c-0.4,0-0.6,0-1-0.2C812.7,121.61,812.9,121.81,813.51,121.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M272.3,422.41l3.8-2.2c-11.8,6.8-22,14.2-32.4,29.2C251.51,438.41,261.1,429.01,272.3,422.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M791.7,124.21c0.6-0.2,1.4-0.4,2-0.8C792.9,123.61,792.51,124.01,791.7,124.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M233.31,916.21c-1.6-1.4-3.2-3-4.6-4.6C229.9,913.41,231.51,914.81,233.31,916.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M781.3,129.01c-0.6,0.4-1.4,0.8-2.2,1.2c1-0.6,2.2-1.2,3.2-1.8C782.31,128.61,781.7,128.61,781.3,129.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M226.7,908.81c-1-1.6-2-3.4-2.8-5.2C224.9,905.21,225.91,906.81,226.7,908.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M803.31,121.21c0.2,0,0.4,0,0.8,0C803.71,121.21,803.51,121.21,803.31,121.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M260.91,520.21v343.4c0,2.2,1,4.2,3,5.4c1,0.6,2,0.8,3.2,0.8c1,0,2-0.2,3-0.8l535.4-309.2 c2-1.2,3.2-3.2,3.2-5.4v-343.4c0-2.2-1.2-4.2-3.2-5.2c-1.8-1.2-4.2-1.2-6,0l-535.6,309C261.7,516.21,260.91,518.01,260.91,520.21z  M267.11,520.21l535.4-309.2v343.4l-535.4,309.2L267.11,520.21L267.11,520.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M802.51,211.01l-535.4,309.2v343.4l535.4-309.2V211.01z M796.3,551.21l-523.2,302v-329.2l523.2-302V551.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M553.9,477.21c1,0,2-0.2,3.2-0.8l193.4-111.6c3-1.8,3.8-5.6,2.2-8.4c-1.8-3-5.6-4-8.6-2.2l-193.4,111.8 c-3,1.6-3.8,5.4-2.2,8.4C549.91,476.01,551.7,477.21,553.9,477.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M553.9,530.21c1,0,2-0.2,3.2-0.8l193.4-111.8c3-1.6,3.8-5.4,2.2-8.4c-1.8-3-5.6-4-8.6-2.2l-193.4,111.6 c-3,1.8-3.8,5.4-2.2,8.4C549.91,529.01,551.7,530.21,553.9,530.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M553.9,583.61c1,0,2-0.4,3.2-0.8l193.4-111.8c3-1.6,3.8-5.4,2.2-8.4c-1.8-3-5.6-4-8.6-2.2l-193.4,111.6 c-3,1.8-3.8,5.6-2.2,8.4C549.91,582.61,551.7,583.61,553.9,583.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M419.9,612.81l0.4,4.2c7.6-15.2,13.4-32.8,15.8-50.4c-2.4,13.4-7.2,28.2-14.2,42.4 C421.51,610.21,420.91,611.41,419.9,612.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M348.91,647.61c-7.4-6.6-12.4-16-15.2-26.6c2.4,13.2,7.8,23.6,15.2,31l0.2-4 C349.1,647.81,349.1,647.81,348.91,647.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M343.91,674.41L343.91,674.41l8.2-1.2c1.2-2.2,2-4.6,2.2-6.8l0.6-9.6c-2.2-1.4-4-3.2-5.8-5l-1,14.2 c-0.2,2.6-2.2,6.2-4.8,8l-2,1.4c0,0,0,0.2-0.2,0.2C342.11,675.21,342.71,674.81,343.91,674.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M415.31,631.41c0.2,1.2,0.4,2,1,2.8l3.4-3.4c0.2-0.2,0.2-0.2,0.4-0.4l0,0c0.6-0.6,1.2-1,1.8-1.2h-0.2 c0,0-0.2,0-0.4,0.2l-1-12.2c-1.8,3.4-3.6,6.6-5.4,9.8L415.31,631.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M355.31,652.41c-2-1.2-4-2.6-6-4.2l-0.2,4c1.8,1.8,3.8,3.6,5.8,5L355.31,652.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M414.71,622.61l0.4,4.2c1.8-3.2,3.6-6.4,5.4-9.8l-0.4-4.2C418.31,616.41,416.51,619.81,414.71,622.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M412.3,638.61l4.2-4.2c-0.4-0.8-0.8-1.6-1-2.8l-0.4-4.6c-1.6,2.6-3.2,5.2-5,7.6 C410.5,636.01,411.1,637.41,412.3,638.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M360.31,666.81l0.4-7c-1.6-0.6-3.2-1-4.8-2c-0.4-0.2-0.8-0.6-1.2-1l-0.6,9.6c-0.2,2.2-1,4.6-2.2,6.8l6.8-1 C359.51,670.41,360.31,668.81,360.31,666.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M360.91,660.01l0.4-5c-2-0.8-4-1.6-6-2.8l-0.4,4.8c0.4,0.2,0.6,0.8,1.2,1 C357.3,658.81,359.1,659.21,360.91,660.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M409.51,631.81c0,1,0.6,1.6,0.8,2.4c1.6-2.4,3.4-5,5-7.6l-0.4-4.2c-1.8,2.8-3.6,5.4-5.4,8L409.51,631.81 L409.51,631.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M381.51,529.61c6.4-3.8,12.6-9.2,18.2-14.2c7.6-6.6,15.4-13.6,22.6-12.8c-0.8-2.2-2-3.8-3.4-4.6 c-0.8-0.6-2.2-1-4.4-1c-4.6,0-12.6,2.2-27,10.2c-19.2,11-29.6,21.8-35.6,33.2c3.8-2,7.8-3.2,12-4.2 C369.71,534.81,375.31,533.41,381.51,529.61z"
}), React.createElement("path", {
  className: "st1",
  d: "M371.51,511.01c1.2-0.8,2.4-1.8,3.8-2.6C373.91,509.21,372.71,509.81,371.51,511.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M423.91,494.21c-0.8-1.8-1.8-3.4-3.2-4.2c-0.8-0.6-2.2-1-4.4-1c-4.6,0-13.2,2.2-28.6,11 c-4.2,2.4-7.6,4.8-11,7.2c2.6-1.6,5.2-3.4,8-5C405.91,489.81,417.3,488.61,423.91,494.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M346.1,544.41c1.8-1.6,3.8-3,5.8-4c6-11.4,16.6-22.2,35.6-33.2c14.2-8.2,22.2-10.2,27-10.2 c2.2,0,3.6,0.4,4.4,1c1.4,0.8,2.6,2.6,3.4,4.6c1.2,0.2,2.4,0.6,3.6,1.2c-0.4-4-1.2-7.2-2.2-9.8c-6.4-5.4-18-4.2-39,8 c-2.8,1.6-5.6,3.4-8,5c-0.6,0.4-1.2,0.8-1.6,1c-1.4,0.8-2.4,1.8-3.8,2.6C356.7,521.81,349.71,532.81,346.1,544.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M332.11,592.41c-0.4-33.6-0.8-62.8,41.6-90.6c3.4-2.4,7.2-4.8,11.2-7.2c27.2-15.6,39-14.4,44.2-4.2 c9,9,8.8,27.2,8.6,48.2c0,1.8,0,4,0,5.8l0.8,2.8c0-1.4,0.4-3,0.4-4.4l0.2-3.6c0-3.8,0-7.6,0-11.4c0.4-22,0.8-41.2-11.8-48.6 c-9.6-5.6-23.4-2.6-45.2,10c-52,30-51.4,59.6-51,93.8c0,3.6,0.2,7.4,0.2,11.2l0.2,2.4c-0.2,0.2-0.2,1.2-0.2,1.6 c0,1.6,0.4,3.2,0.4,4.8l0.6-3.8C332.11,596.81,332.11,594.41,332.11,592.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M335.5,573.01c0.2-4.6,0.2-9.2,1.6-14.2c1.8-20.4,9-38.6,36.2-57.2c-42.4,27.8-42.2,57-41.6,90.6 c0.2,2.2,0.2,4.6,0.2,7l2.4-12.6C335.31,581.41,335.5,577.21,335.5,573.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M433.91,523.61c0.2,4,0.2,8.2,1.2,11.6l2.4,9.2c0-2,0-4,0-5.8c0.4-20.8,0.6-39-8.6-48.2c2.6,5.2,3.4,13,3.6,22 C433.5,516.01,433.5,519.81,433.91,523.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M425.31,487.41c1.4,0.8,2.6,1.8,3.6,3c-5.2-10.2-17-11.4-44.2,4.2c-4.2,2.4-7.8,4.8-11.2,7.2 c2.6-1.6,5.2-3.4,8.2-5C402.3,484.81,415.91,481.81,425.31,487.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M337.3,558.81c0.4-1.8,1.2-3.6,2-5.4c0.6-1.2,1.4-2,2-3c4-14,12.4-26.8,30-39.6c1.2-0.8,2.4-1.8,3.8-2.6 c0.6-0.4,1-0.6,1.6-1c3.4-2.4,6.8-4.8,11-7.2c15.2-8.6,23.8-11,28.6-11c2,0,3.6,0.4,4.4,1c1.4,0.8,2.4,2.2,3.2,4.2 c3.4,2.8,5.4,7.4,6.4,13.4c1.2,1.4,2,3.2,2.4,5c-0.2-9-1-16.8-3.6-22c-1-1-2.2-2.2-3.6-3c-9.4-5.6-23-2.6-43.6,9.2 c-2.8,1.6-5.6,3.4-8.2,5C346.1,520.21,339.1,538.61,337.3,558.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M375.31,508.01c0.4-0.4,1.2-0.8,1.6-1C376.1,507.41,375.5,507.81,375.31,508.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M346.1,544.41c3.4-11.8,10.6-22.6,25.2-33.8c-17.6,12.8-26.2,25.8-30,39.6 C342.71,548.01,344.3,546.21,346.1,544.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M428.91,505.61c0.6,0.6,1,1.2,1.4,1.8c-1-6-3-10.6-6.4-13.4c1.2,2.6,1.8,5.8,2.2,9.8 C427.11,504.21,427.71,504.81,428.91,505.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M422.71,628.81c-0.2,0-0.2,0.2-0.4,0.2l0,0C422.3,629.01,422.3,628.81,422.71,628.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M389.1,754.21c-0.6,0.6-1.4,0.6-2.2,1c-0.4,0.6-1,1.4-1.8,1.8l-72.4,42l150.4-86.8l-72.6,41.8 C389.9,754.21,389.71,754.01,389.1,754.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M378.5,674.41c0-3.4,2.8-6.2,6.2-6.2c1.6,0,3.2,0.8,4.4,1.8l27.4-27.4c0-0.4,0.2-0.6,0.2-1 c-0.6-0.2-1.2-0.4-1.8-0.8c-1.2-0.6-2-1.6-2.8-2.6l-30.2,30.2l-23.2,3.6c-0.8,2.4-2,4.6-3.8,6.8l23.6-3.6L378.5,674.41 L378.5,674.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M418.5,633.61c0.2-1,0.6-1.8,1.2-2.6l-3.4,3.4c0.4,0.6,1,1.2,1.6,1.4C418.31,635.01,418.5,634.21,418.5,633.61 z"
}), React.createElement("path", {
  className: "st2",
  d: "M420.31,630.21c0.6-0.6,1.2-1,1.8-1.2l0,0C421.51,629.61,420.91,629.81,420.31,630.21L420.31,630.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M349.51,676.41c0.8-1,2-1.8,2.6-3l-8,1.2c0,0,0,0-0.2,0c1-0.2,2-0.2,2.8,0.2 C347.71,675.21,348.5,675.61,349.51,676.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M414.71,641.21c0.6,0.4,1.2,0.6,1.8,0.8c0.4-2,0.8-4,1.4-6.2c-0.6-0.4-1.2-0.8-1.6-1.4l-4.2,4.2 C412.9,639.61,413.91,640.41,414.71,641.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M350.91,679.01c0,0.2,0.2,0.4,0.2,0.6l4-0.6c1.6-2.2,2.8-4.4,3.8-6.8l-6.8,1c-0.6,1.2-1.6,2-2.6,3 C349.9,677.21,350.5,678.01,350.91,679.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M404.71,663.41l9-9c1-3.6,1.8-7.4,2.8-11.4l-27.4,27.4c0.2,0.2,0.2,0.4,0.2,0.6L404.71,663.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M352.9,685.61l8.4-1.2l17.2-8.4v-0.6l-23.6,3.6c-1,1.2-1.8,2.6-3,3.8L352.9,685.61z"
}), React.createElement("polygon", {
  className: "st2",
  points: "391.51,676.41 390.91,676.81 390.91,677.21  "
}), React.createElement("path", {
  className: "st2",
  d: "M404.71,663.41l-15.4,7.6c0.8,1,1.6,2.2,1.6,3.8v2.4l0.6-0.2L404.71,663.41z"
}), React.createElement("polygon", {
  className: "st2",
  points: "378.5,676.01 361.51,684.21 378.5,681.61  "
}), React.createElement("path", {
  className: "st2",
  d: "M352.9,685.61l-1-2.8c1.2-1,2-2.4,3-3.8l-4,0.6c0.6,2.2,1.2,4,1.8,6H352.9z"
}), React.createElement("path", {
  className: "st2",
  d: "M436.1,566.61c1.2-6.4,2-12.4,2-18c0-0.6,0-1-0.2-1.6l0,0c-0.2,4-0.6,8.2-1.4,12.6 C436.51,561.81,436.51,564.21,436.1,566.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M331.51,602.81v0.6c0,6.2,1,12,2.4,17.6c-0.4-2-0.4-4.2-0.6-6.2C332.3,611.01,331.51,607.21,331.51,602.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M349.1,647.81l0.2-4.4c-0.8-1.2-1.8-2.2-2.6-3.6c-6.6-6.4-11.2-15-13.8-25.2c0.2,2,0.2,4.4,0.6,6.2 c2.8,10.8,7.8,20.2,15.2,26.6C349.1,647.81,349.1,647.81,349.1,647.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M423.31,601.21c-1.2,2.4-2.4,4.4-3.6,6.6l0.4,5.2c0.6-1.4,1.4-2.4,2-3.8c6.8-14.2,11.6-28.8,14.2-42.4 c0.4-2.4,0.4-4.8,0.6-7C434.71,572.81,429.9,587.21,423.31,601.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M347.71,641.01c-0.4-0.4-0.6-0.8-1-1c0.8,1.4,1.8,2.4,2.6,3.6v-1.4C349.1,641.61,348.5,641.41,347.71,641.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M387.71,652.41c7.2-4,14.6-11.8,21.4-21.6l-0.4-5c-7.4,12.4-16,22-24,26.6c-8,4.6-16.2,4.8-23.6,1.4v1.4 c3.4,1.2,6.8,1.8,10.2,1.8C376.7,656.81,382.71,655.21,387.71,652.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M384.71,652.41c8-4.6,16.6-14.2,24-26.6v-1c-6.8,9-13.8,16-20.8,20c-0.4,0.2-0.6,0.2-1,0.4 c-0.8,0.4-1.4,1.2-2.2,1.6c-8,4.6-16,4.6-23.4,1.6l-0.4,5.2C368.5,657.21,376.7,656.81,384.71,652.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M349.51,643.61l-0.2,4.4c1.8,1.6,3.8,3,6,4.2l0.2-2.6C353.31,647.81,351.1,646.01,349.51,643.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M414.71,622.61c1.8-3,3.6-6.4,5.4-9.8l-0.4-5.2c-1.8,3.2-3.6,6.4-5.4,9.4L414.71,622.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M355.31,649.81l0.2-3.8c-2-1-4-2.2-6-3.8v1.4C351.1,646.01,353.31,647.81,355.31,649.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M361.1,653.61c-2-1-4-2.4-5.8-4l-0.2,2.6c2,1.2,4,2,6,2.8L361.1,653.61L361.1,653.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M411.51,621.01c-0.8,1.6-1.6,3.2-2.6,4.6l0.4,5c1.8-2.6,3.6-5,5.4-8l-0.4-5.8 C413.31,618.61,412.3,619.81,411.51,621.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M359.9,647.81c-1.6-0.6-3-1.4-4.4-2l-0.2,3.8c1.8,1.6,3.8,3,5.8,4l0.4-5.2 C360.91,648.41,360.31,648.01,359.9,647.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M408.91,625.61c0.8-1.4,1.6-3.2,2.6-4.6c-0.8,1.2-1.8,2.6-2.6,3.8V625.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M365.5,542.41c5.8-1.6,12.4-3.4,19.2-7.4c7-4,13.2-9.6,19.2-14.8c8.6-7.4,15.6-13.8,20.4-10 c-0.4-2.8-1-5.4-1.8-7.4c-7.2-0.8-15,6-22.6,12.8c-5.6,4.8-11.8,10.4-18.2,14.2c-6.2,3.6-12,5.2-17.8,6.8c-4,1-8,2.4-12,4.2 c-2,4-3.6,8-4.8,12C351.7,546.41,358.31,544.21,365.5,542.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M347.3,552.61c1.2-4.2,2.8-8.2,4.8-12c-2,1-4,2.4-5.8,4c-1.6,5.4-2.4,10.8-2.8,16.6c0.4-1.6,0.6-3.2,1.4-5 C345.5,555.01,346.51,553.81,347.3,552.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M424.71,510.41c1,1,1.4,2.4,1.8,4c0-3.6-0.2-7.2-0.4-10.4c-1.2-0.6-2.4-1-3.6-1.2c0.8,2,1.4,4.6,1.8,7.4 C424.3,510.41,424.71,510.01,424.71,510.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M437.3,550.21c0,3-0.4,6.2-0.6,9.2c0.8-4.4,1.2-8.6,1.4-12.6l-0.8-2.8C437.3,546.41,437.3,548.41,437.3,550.21 z"
}), React.createElement("path", {
  className: "st2",
  d: "M332.3,604.01c0-1.6,0-3.2,0-4.8l-0.6,3.8c0.2,4.2,0.8,8,1.8,11.8C332.71,611.41,332.3,607.81,332.3,604.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M337.3,603.61l0.2-0.6c-0.2-1.6-0.4-3-0.4-4.6v-0.4l0.2-0.2c-0.2-1.2-0.2-2.2-0.2-3.4 c0-12.8-0.6-24.4,0.2-35.4c-1.4,5-1.6,9.8-1.6,14.2c0,4-0.2,8.4-1.2,13.6l-2.4,12.6c0,1.6,0,3.2,0,4.8c0,3.8,0.6,7.2,1,10.8 c2.4,10,7,18.8,13.8,25.2c-3.4-5.4-5.8-12.4-7.2-20.4C338.5,614.41,337.3,609.21,337.3,603.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M433.91,523.61c0-3.8-0.2-7.6-1.2-11c0.2,8.2-0.2,17.4-0.2,26.8c0,1.2,0,2.2,0,3.4v0.6c0,1.6-0.4,3.6-0.4,5.4 v0.4c0,5.8-0.8,12-2.2,18.4c-1.8,12.8-5.6,25.4-10.6,37.2l0.2,3.2c1.4-2.6,2.6-4.6,3.8-6.8c6.8-13.8,11.4-28.2,13.6-41.4 c0.2-3,0.6-6.2,0.6-9.2c0-2,0-4,0-6l-2.4-9.2C434.1,531.61,434.1,527.61,433.91,523.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M419.51,604.41c4.8-11.8,8.8-24.6,10.6-37.2c-2.2,11-6,22.6-10.8,33.6L419.51,604.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M349.71,642.21l0.2-2.6c-4.6-5.2-8-12-10.2-20c1.4,8,4,14.8,7.2,20.4c0.4,0.4,0.6,0.8,1,1 C348.5,641.41,349.1,641.61,349.71,642.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M387.11,645.21c0.4-0.2,0.6-0.2,1-0.4c7-4,14-11.2,20.8-20l-0.4-3.8C401.51,631.61,394.1,640.21,387.11,645.21 z"
}), React.createElement("path", {
  className: "st2",
  d: "M414.1,616.01v1.2c1.8-3,3.6-6.2,5.4-9.4l-0.2-3.2C417.71,608.41,415.91,612.41,414.1,616.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M352.71,643.01c-1.2-1-2-2.4-3-3.6l-0.2,2.6c2,1.6,4,2.6,6,3.8v-0.8C354.71,644.21,353.5,643.81,352.71,643.01 z"
}), React.createElement("path", {
  className: "st2",
  d: "M416.51,606.41c-1,1.8-2,3.4-2.8,5.2l0.4,4.2c1.8-3.6,3.6-7.6,5.2-11.4l-0.4-3.6 C418.31,602.61,417.3,604.41,416.51,606.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M414.1,616.81v-1.2c-0.8,1.8-1.8,3.4-2.8,5.2C412.3,619.81,413.31,618.61,414.1,616.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M355.5,645.01v0.8c1.4,0.8,2.8,1.6,4.4,2C358.5,647.21,357.11,646.21,355.5,645.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M408.5,621.01l0.4,3.8c0.8-1.2,1.8-2.4,2.6-3.8c1-1.6,1.8-3.4,2.8-5.2l-0.4-4.2 C412.11,615.01,410.31,618.01,408.5,621.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M431.1,545.61l0.8,2.8c0.2-1.8,0.4-3.6,0.4-5.4v-0.6c0-1.2,0-2.2,0-3.4c0-9.4,0.4-18.6,0.2-26.8 c-0.4-1.8-1.4-3.4-2.4-5C432.11,517.61,431.51,531.21,431.1,545.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M341.51,550.41c-0.6,1-1.4,1.8-2,3c-0.8,1.8-1.4,3.6-2,5.4c-1,11-0.2,22.6-0.2,35.4c0,1.2,0,2.2,0.2,3.4 l-0.2,0.2v0.4c0,1.6,0.4,3.2,0.4,4.6l0.8-3.8C337.9,581.21,337.3,565.21,341.51,550.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M425.91,504.01c0.4,3.2,0.4,6.8,0.4,10.4c0.8,2.6,1.2,5.8,1.2,9.4c0,4.2,0.2,8.8,1.2,13l2.4,8.8 c0.2-14.4,0.6-28.2-1.2-38.2c-0.4-0.6-0.8-1.2-1.4-1.8C427.71,504.81,427.11,504.21,425.91,504.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M338.31,599.01l2.2-11.2c1.2-5.6,1.2-10.2,1.4-14.6c0-4,0.4-8,1.6-12c0.4-5.8,1.4-11.4,2.8-16.6 c-1.8,1.6-3.4,3.6-4.8,5.8C337.3,565.21,337.9,581.21,338.31,599.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M377.3,648.81c-2.2,0.4-4.2,0.8-6.4,1C372.9,650.01,375.31,649.61,377.3,648.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M370.91,649.81c-0.2,0-0.6,0.2-0.8,0.2c-3,0-5.8-0.8-8.6-1.6v0.2c7.2,3,15.4,3,23.4-1.6 c0.8-0.4,1.4-1.2,2.2-1.6c-3.2,1.8-6.4,3-9.8,3.6C375.31,649.61,372.9,650.01,370.91,649.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M359.9,647.81c0.4,0.2,1,0.2,1.6,0.6v-0.2C360.91,648.01,360.31,648.01,359.9,647.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M347.9,573.61c0.2-5.4,0.2-9.8,2.4-14.4c3.4-6.8,7.8-8.2,16.8-10.8c6-1.6,13-3.6,20.4-8 c7.6-4.4,14.4-10.4,20.4-15.6c4.4-3.8,10.8-9.6,12.4-10c0.8,1,1,6.2,1,9.2c0.2,4.4,0.4,9.6,1.6,14.6l2,7.8c0-2.6,0-5.4,0-8 c0.2-10.2,0.2-20.4-0.8-28.2c-4.8-3.8-11.8,2.4-20.4,10c-6,5.2-12.2,10.8-19.2,14.8s-13.4,5.8-19.2,7.4c-7.4,2-13.6,4-18.2,10.4 c-3.2,11.8-3.2,24.4-3,39.4c0,2.4,0,5,0.2,7.6l2.2-10.6C347.71,582.81,347.9,577.61,347.9,573.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M424.1,510.01c1.2,7.8,1,18,0.8,28.2c0,2.6,0,5.4,0,8l0.8,2.8c0.2-2,0.4-4,0.4-6v-4c0-3.8,0-7.8,0-11.6 c0-4.6,0.2-9,0.2-13.4c-0.4-1.4-0.8-3-1.8-4C424.71,510.01,424.3,510.41,424.1,510.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M342.9,582.81c0,3.8,0.2,7.6,0.2,11.4v3c0,2,0.2,3.8,0.4,5.8l0.6-3.4c0-2.6-0.2-5.2-0.2-7.6 c-0.2-15-0.2-27.6,3-39.4c-0.8,1.2-1.8,2.2-2.4,3.6c-0.8,1.8-1,3.4-1.4,5C342.9,567.81,342.9,575.21,342.9,582.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M429.9,567.21c1.2-6.4,2.2-12.6,2.2-18.4v-0.4c-0.2,3.8-0.6,7.6-1.4,11.6 C430.31,562.41,430.31,564.81,429.9,567.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M337.3,602.81l-0.2,0.6c0,5.8,1,11,2.2,16c-0.4-2-0.4-4.4-0.6-6.6C338.31,609.81,337.71,606.41,337.3,602.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M338.91,612.81c0.2,2.2,0.4,4.6,0.6,6.6c2,8,5.6,14.8,10.2,20l0.4-5.2 C344.9,629.01,340.91,621.61,338.91,612.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M418.5,596.21l0.4,4.6c5-11,8.8-22.6,10.8-33.6c0.4-2.4,0.4-4.8,0.6-7.2 C428.5,571.81,424.1,584.41,418.5,596.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M384.71,639.61c-0.4,0.2-0.6,0.2-1,0.4c-0.8,0.4-1.4,1.2-2.2,1.6c-7.6,4.4-14.2,3.2-19,0.8 c-0.2,0-0.6-0.2-0.8-0.2l-0.4,4.6c0.2,0.2,0.4,0.4,0.6,0.6c2.8,1.6,5.6,2.4,8.6,2.4c2.2,0,4.2-0.4,6.4-1c1.4-0.4,3-1,4.4-2 c8.2-4.8,17-15.6,24.6-29.4C399.71,627.21,392.3,635.21,384.71,639.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M361.51,646.61l-0.2,1.6c2.8,0.8,5.6,1.6,8.6,1.6c0.2,0,0.6-0.2,0.8-0.2c-3-0.2-6-0.8-8.6-2.4 C362.11,647.21,361.7,646.81,361.51,646.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M408.5,621.01l-0.4-5.8c-0.6,0.8-1,1.6-1.6,2.2c-7.6,13.8-16.4,24.6-24.6,29.4c-1.4,0.8-3,1.4-4.4,2 c3.2-0.8,6.4-2,9.8-3.6C394.1,640.21,401.51,631.61,408.5,621.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M352.71,636.81c1,1.6,2,3.4,3.2,4.8l0.2-2.4C354.71,638.61,353.5,637.61,352.71,636.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M413.31,606.41l0.4,5.2c1-1.8,2-3.4,2.8-5.2s1.6-3.8,2.4-5.6l-0.4-4.6c-0.4,0.8-0.6,1.4-1,2.2 C416.51,601.21,414.71,603.81,413.31,606.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M355.5,645.01l0.2-3.4c-1.2-1.4-2.2-3-3.2-4.8c-0.2-0.2-0.6-0.4-0.8-0.6c-0.6-0.6-1.2-1.4-1.6-2l-0.4,5.2 c1,1.2,2,2.6,3,3.6C353.5,643.81,354.71,644.21,355.5,645.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M361.7,642.21c-2-0.8-4-1.6-6-2.8l-0.2,2.4c1.8,2,3.6,3.8,5.8,5L361.7,642.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M361.51,646.61c-2.2-1.4-4-3-5.8-5l-0.2,3.4c1.4,1,2.8,2.2,4.4,3c0.6,0.2,1,0.2,1.6,0.2L361.51,646.61 L361.51,646.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M407.9,615.21l0.4,5.8c1.8-3,3.6-6.2,5.4-9.4l-0.4-5.2C411.51,609.61,409.71,612.41,407.9,615.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M350.31,632.61l0.2-2.8c-1.2-2-2.4-4-3.2-6.2C347.9,627.21,349.1,630.21,350.31,632.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M418.31,590.21c2.8-8.4,4.8-17,6-25.6c-1.4,7.2-3.4,14.8-6.2,22.6L418.31,590.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M431.1,550.21c0,3.2-0.4,6.4-0.6,9.6c0.8-4,1.2-7.8,1.4-11.6l-0.8-2.8C431.1,547.41,431.1,548.81,431.1,550.21 z"
}), React.createElement("path", {
  className: "st2",
  d: "M338.31,604.01c0-1.6,0-3.2,0-4.8l-0.8,3.8c0.2,3.4,0.8,6.8,1.4,10C338.5,610.01,338.31,607.21,338.31,604.01z "
}), React.createElement("path", {
  className: "st2",
  d: "M426.51,527.61c0,3.8,0,7.6,0,11.6v4c0,1.8-0.4,4-0.4,6l0.2,0.4c-0.2,4.6-0.8,9.8-1.8,15.2 c-1.2,8.6-3.2,17.2-6,25.6l0.6,5.8c5.6-11.8,9.8-24.2,12-36.2c0.2-3.2,0.6-6.4,0.6-9.6c0-1.6,0-3.2,0-4.6l-2.4-8.8 c-1-4.2-1.2-8.8-1.2-13c-0.2-3.6-0.4-6.8-1.2-9.4C426.51,518.61,426.51,523.01,426.51,527.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M347.3,623.81c-2.4-5.8-3.6-12.4-3.8-19.2l0.4-1.6c-0.2-1.8-0.6-3.6-0.6-5.6v-3c0-3.8-0.2-7.6-0.2-11.4 c-0.2-7.8-0.2-14.8,0.2-21.6c-1,4-1.6,8-1.6,12c-0.2,4.4-0.2,9-1.4,14.6l-2.2,11.2c0,1.6,0,3.2,0,4.8c0,3.2,0.4,6,0.6,8.8 c2.2,8.8,6,16.2,11.2,21.6l0.2-1.6C349.1,630.21,347.9,627.21,347.3,623.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M361.7,641.81L361.7,641.81c0.2,0.2,0.6,0.2,0.8,0.4C362.3,642.21,362.3,642.21,361.7,641.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M407.3,610.21c-7.6,13.8-16,24.4-23.8,29.8c0.4-0.2,0.6-0.2,1-0.4c7.4-4.4,14.8-12.4,21.6-22 c0.6-1,1-1.8,1.6-2.8L407.3,610.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M406.51,617.61c0.6-0.8,1-1.4,1.6-2.2v-0.6C407.3,615.61,406.7,616.41,406.51,617.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M355.91,637.61c-2.2-2.2-4-4.6-5.6-7.4l-0.2,2.8c0.6,1.4,1.6,2.8,2.4,4.2c1,0.8,2.2,1.6,3.4,2.2V637.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M412.71,599.81l0.4,4c1.8-4.4,3.6-8.8,5-13.4l-0.2-3C416.51,591.41,414.71,595.41,412.71,599.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M412.9,603.81l0.2,2.6c1.4-2.6,3-5.2,4.4-8c0.4-0.8,0.6-1.4,1-2.2l-0.6-5.8 C416.51,595.01,414.9,599.21,412.9,603.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M349.9,634.41c0.6,0.6,1,1.4,1.6,2c0.2,0.2,0.6,0.4,0.8,0.6c-0.8-1.4-1.6-2.6-2.4-4.2V634.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M357.11,638.61c-0.4-0.2-0.6-0.8-0.8-1l-0.2,1.6c2,1.2,3.8,2.2,6,2.8l0,0 C359.9,641.01,358.31,639.81,357.11,638.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M410.91,603.81c-1.2,2.4-2.4,4.4-3.6,6.6l0.4,4.6c1.8-3.6,3.6-7.2,5.2-11l-0.4-4 C412.3,601.21,411.51,602.41,410.91,603.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M412.9,603.81c-1.6,3.8-3.4,7.4-5.2,11v0.6c1.8-2.8,3.6-5.8,5.4-8.8L412.9,603.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M364.3,736.41c-8-11.6-14.2-21.2-20.2-37.4c0-0.2-0.2-0.2-0.2-0.4l-0.4-1.4c-0.6-2-1.4-3.6-2-5.6 c-0.2,0.2-0.4,0.4-0.6,0.6c-2.6,2.4-5.2,4.6-7.6,7c-0.6,0.6-1.2,1.2-1.8,1.8c-2.2,2.2-4.4,4.4-6.4,6.6c-0.6,0.8-1.4,1.6-2,2.2 c-1.8,2-3.4,4-5,6c-0.8,1-1.4,1.8-2.2,2.8c-1.4,1.8-2.6,3.6-3.8,5.2c-0.8,1.2-1.4,2.2-2.2,3.4c-1,1.6-1.8,3-2.6,4.6 c-0.8,1.4-1.2,2.6-1.8,4c-0.6,1.2-1.2,2.4-1.6,3.6c-0.6,1.6-1,3-1.4,4.4c-0.2,1-0.6,1.8-0.8,2.8c-0.4,2.4-0.8,4.6-0.8,6.8v32.8 c0,1.8,0.6,3,0.8,3.2c0.6,0.4,2.2,0.4,4.8-1.2l66.8-38.6l-2.2-3.2C368.5,742.61,366.51,739.61,364.3,736.41z"
}), React.createElement("path", {
  className: "st1",
  d: "M424.1,665.01c-0.2,0.4-0.6,0.6-0.8,1c-5,18.6-10.6,33-17.6,51.6l-6.6,17.2l57.6-33.2c6.4-3.6,12-12.8,12-19.4 v-32.8c0-5.2-1.6-9-4.6-11c-1.4-1-3.4-1.8-5.6-2.4c-1.2-0.2-2.8-0.2-4.2-0.2c-1.2,0-2.4-0.2-3.8-0.2s-3.2,0.4-4.8,0.6 c-1.8,0.2-3.4,0.4-5.2,0.8c-1.6,0.4-3.4,0.8-5,1.2c-1.8,0.4-3.6,1-5.6,1.6L424.1,665.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M424.1,665.01l5.6-25.4c0,0,0,0-0.2,0c-2.2,10-4.2,18.6-6.4,26.4C423.5,665.41,424.1,665.21,424.1,665.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.1,698.61c0,0.2,0.2,0.2,0.2,0.4c-0.2-0.6-0.4-1.2-0.6-1.8L344.1,698.61z"
}), React.createElement("path", {
  className: "st1",
  d: "M309.9,727.21c0.6-1.2,1.4-2.2,2.2-3.4C311.51,725.01,310.91,726.21,309.9,727.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M300.91,753.41c0-2.2,0.2-4.4,0.8-6.8C300.91,748.81,300.91,751.21,300.91,753.41z"
}), React.createElement("polygon", {
  className: "st1",
  points: "373.5,749.81 373.5,749.81 306.51,788.41  "
}), React.createElement("path", {
  className: "st1",
  d: "M458.5,636.01c2.2,0.4,4.2,1.2,5.6,2.4C462.71,637.21,460.91,636.41,458.5,636.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M305.31,735.61c0.6-1.2,1.2-2.6,1.8-4C306.51,733.01,305.91,734.21,305.31,735.61z"
}), React.createElement("path", {
  className: "st1",
  d: "M435.5,637.81c-1.8,0.4-3.6,0.8-5.6,1.4v0.2C431.7,638.81,433.91,638.41,435.5,637.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M302.3,743.81c0.4-1.4,0.8-3,1.4-4.4C303.31,741.01,302.71,742.41,302.3,743.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M399.1,734.81l57.6-33.2L399.1,734.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M323.31,709.81c0.6-0.8,1.4-1.6,2-2.2C324.71,708.01,324.1,708.81,323.31,709.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M450.5,635.21c1.4,0,2.6,0.2,3.8,0.2C453.31,635.41,452.11,635.21,450.5,635.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M331.51,701.01c0.6-0.6,1.2-1.2,1.8-1.8C332.71,699.81,332.3,700.21,331.51,701.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M315.91,718.61c0.8-1,1.4-1.8,2.2-2.8C317.3,716.61,316.7,717.61,315.91,718.61z"
}), React.createElement("path", {
  className: "st1",
  d: "M440.5,636.61c1.8-0.4,3.6-0.6,5.2-0.8C444.1,636.21,442.3,636.41,440.5,636.61z"
}), React.createElement("path", {
  className: "st1",
  d: "M341.51,691.41c-0.2,0.2-0.4,0.4-0.6,0.6C341.1,691.81,341.51,691.61,341.51,691.41L341.51,691.41z"
}), React.createElement("polygon", {
  className: "st1",
  points: "429.9,639.21 429.71,639.21 429.71,639.61 429.71,639.61  "
}), React.createElement("path", {
  className: "st2",
  d: "M341.1,675.61l-0.2,0.2L341.1,675.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M343.91,674.41c-1,0.2-1.8,0.6-2.6,1.2l0,0C342.11,675.21,342.71,674.81,343.91,674.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M419.71,630.61l0.4-0.4C420.31,630.41,419.9,630.61,419.71,630.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M394.1,713.01l-3.2,8.8v17.6l2.8-7.4c9-24.2,15.6-40.2,21.6-60.2l-7.6,3.8 C403.91,687.81,399.51,699.21,394.1,713.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M374.71,729.61c-6.6-10-11.8-17.8-16.8-29.6l-5,2.4c-0.2,0.2-0.4,0-0.6,0.2c6.6,16.2,13.8,24.8,24.2,40.6 l2.4,3.4v-10.8C377.3,733.61,375.91,731.41,374.71,729.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M412.71,659.21l1.2-5.4l-0.2,0.2c-0.4,1.8-1,3.6-1.4,5.4L412.71,659.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M357.71,700.01c-0.8-1.8-1.4-3.8-2.2-5.8l-5.6,2.6c0.8,2,1.4,4,2.2,5.8c0.2,0,0.4,0,0.6-0.2L357.71,700.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M347.11,686.81C347.11,686.81,346.7,686.81,347.11,686.81c1,3.6,2,6.8,3,9.6L347.11,686.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M407.71,675.41l7.6-3.8c0.8-2.6,1.6-5.2,2.4-8l-7.4,3.6C409.51,670.21,408.5,672.81,407.71,675.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M412.71,659.21l-0.4,0.2c-0.8,2.8-1.4,5.4-2.2,8l7.4-3.6c1.6-5.6,3-11.6,4.6-18l-8.2,8.2L412.71,659.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M352.71,685.61l-5.4,0.8c-0.2,0.2-0.2,0.2-0.4,0.4l3,9.6v0.2l5.6-2.6 C354.71,691.41,353.91,688.81,352.71,685.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M302.71,801.81c3,0,6.6-1,10-3l72.4-42c0.8-0.4,1.4-1,1.8-1.8c-0.8,0.4-1.4,0.8-2.2,0.8c-2.2,0-4-1.4-5-3.2 l-35.2,20.4l-7.2,4.2l-27.8,16c-8.2,4.8-15,1.4-15-7.4c0-11,0-21.8,0-32.8c0-21,19.4-46.2,45.4-68.4l-0.8-2.4c-0.8-2.4,0-5,2-6.6 h-0.2c-19.6,16-52.6,47.4-52.6,77.4v32.8c0,6.2,2.6,11.4,7.2,14C297.71,801.41,299.9,801.81,302.71,801.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M428.5,629.81c1,0.8,1.8,2,2,3.2c25.6-7.4,44.4-4.4,44.4,16.2v32.8c0,8.8-6.8,20-15,24.8l-69,40v3.4 c0,1.6-0.6,3.2-1.8,4.2c0.4-0.2,0.8-0.2,1.2-0.4l72.6-41.8c10-5.8,18-19,18-30v-32.8c0-11.8-5.2-18-9.8-21c-10-7.2-26.4-7-48.8,0.6 c-0.2,0-0.2,0.2-0.4,0.2C424.1,628.01,426.51,628.41,428.5,629.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M416.51,642.61l0.2-0.8l0,0C416.51,642.21,416.51,642.61,416.51,642.61L416.51,642.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M417.9,635.61c1.4,0.8,3.4,0.6,5.8-0.6l1-0.6l0,0c2-0.6,3.8-1.2,5.8-1.8c-0.4-1.2-1-2.4-2-3.2 c-1.8-1.4-4.4-1.6-6.4-0.6c-0.6,0.4-1.4,0.8-1.8,1.2l-0.4,0.4c-0.6,0.8-1,1.6-1.2,2.6C418.5,634.21,418.31,635.01,417.9,635.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M344.9,680.41L344.9,680.41l2-1.4c1-0.8,1.6-1.8,2.4-2.8c-0.8-0.8-1.6-1.2-2.6-1.6c-1-0.2-2-0.4-2.8-0.2 c-1,0.2-1.8,0.6-2.6,1.2c-2,1.6-2.8,4.2-2,6.6l0.8,2.4C341.51,683.61,343.31,681.81,344.9,680.41L344.9,680.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M350.91,679.01c-0.2-1-0.8-2-1.6-2.8c-0.8,1-1.4,2-2.4,2.8l-2,1.4l0,0l6-1 C350.91,679.61,350.91,679.21,350.91,679.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M416.51,642.61l8-8c0,0,0,0,0.2,0l0,0l-1,0.6c-2.2,1.2-4.2,1.4-5.8,0.6c-0.4,2.2-1,4.2-1.4,6.2l0,0V642.61z"
}), React.createElement("polygon", {
  className: "st2",
  points: "337.3,777.61 344.71,773.41 309.51,793.61  "
}), React.createElement("path", {
  className: "st2",
  d: "M414.1,653.81l2.6-11.2l0,0c-1,4-1.8,7.8-2.8,11.4L414.1,653.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M344.9,680.41L344.9,680.41c0.6,2.4,1.2,4.2,1.8,6.4l0,0L344.9,680.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M422.3,645.61c0.8-3.6,1.6-7.2,2.4-11l-8,8l-2.6,11.2L422.3,645.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M347.3,686.41l5.4-0.8c-0.6-2-1.2-3.8-1.8-6l-6,1l2,6.2C347.11,686.61,347.3,686.61,347.3,686.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M325.31,707.61c2-2.2,4.2-4.4,6.4-6.6C329.51,703.01,327.3,705.21,325.31,707.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M423.5,666.01c-0.6,1.2-1.4,2.6-2.4,3.2l-5.6,2.8c-6,20-12.6,36-21.6,60.2l-2.8,7.4l0,0l8.4-4.8l6.6-17.2 C412.9,698.81,418.5,684.41,423.5,666.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M333.5,699.01c2.4-2.4,5-4.6,7.6-7C338.5,694.41,335.91,696.61,333.5,699.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M301.51,746.41c0.2-0.8,0.6-1.8,0.8-2.8C302.3,744.81,301.7,745.61,301.51,746.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M342.11,691.41l-0.2,0.2c0.6,2.2,1.4,3.8,2,5.6L342.11,691.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M318.31,715.61c1.6-2,3.2-4,5-6C321.51,711.61,319.71,713.81,318.31,715.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M454.3,635.41c1.4,0,3,0,4.2,0.2C457.3,635.61,455.91,635.61,454.3,635.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M435.5,637.81c1.6-0.4,3.4-1,5-1.2C439.1,636.81,437.3,637.61,435.5,637.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M445.91,636.01c1.6-0.2,3.4-0.6,4.8-0.6C449.1,635.41,447.3,635.61,445.91,636.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M376.1,742.81c-10.4-15.8-17.6-24.4-24.2-40.6c-0.8,0.2-1.4,0.4-2.2,0.4s-1.6-0.2-2.4-0.6 c-1.4-0.6-2.6-2-3.2-3.4c6,16.4,12.2,25.8,20.2,37.4c2,3,4.2,6.2,6.6,10l2.2,3.2l5.2-3V746L376.1,742.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M307.3,731.61c0.8-1.4,1.8-3,2.6-4.6C309.1,728.81,308.31,730.21,307.3,731.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M312.3,723.81c1.2-1.8,2.4-3.4,3.8-5.2C314.71,720.21,313.5,722.21,312.3,723.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M303.91,739.21c0.4-1.2,1.2-2.4,1.6-3.6C304.9,736.81,304.1,738.01,303.91,739.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M344.3,698.81c0.6,1.6,1.8,2.8,3.2,3.4c0.8,0.4,1.6,0.6,2.4,0.6c0.6,0,1.4-0.2,2.2-0.4 c-0.8-1.8-1.4-3.8-2.2-5.8l0,0v-0.2c-1-3-2-6.2-3.2-9.6c-1.8,1.4-3.2,2.8-5,4.2l1.8,5.8C344.1,697.61,344.1,698.41,344.3,698.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M417.71,663.81c-0.8,2.8-1.6,5.4-2.4,8l5.6-2.8c1.2-0.6,1.8-2,2.4-3.2c2.2-7.8,4.2-16.4,6.4-26.4 c-0.6,0.2-1.2,0.2-2,0.6l-5.6,5.6l-4,18L417.71,663.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M417.71,663.81l0.6-0.2l4-18l-0.2,0.2C420.5,652.41,419.1,658.41,417.71,663.81z"
}), React.createElement("polygon", {
  className: "st2",
  points: "349.9,696.61 349.9,696.61 349.9,696.41  "
}), React.createElement("polygon", {
  className: "st2",
  points: "394.9,744.21 390.91,746.61 390.91,746.61 459.71,706.61 427.71,725.21  "
}), React.createElement("polygon", {
  className: "st2",
  points: "374.71,755.61 344.71,773.41 379.71,753.01 379.71,752.81  "
}), React.createElement("path", {
  className: "st2",
  d: "M379.71,752.81c-0.6-1-1.2-1.8-1.2-3v-3.4l-5.2,3l0,0l-66.8,38.6c-2.6,1.4-4.4,1.6-4.8,1.2 c-0.4-0.2-0.8-1.4-0.8-3.2v-32.8c0-2.2,0.2-4.4,0.8-6.8c0.2-0.8,0.6-1.8,0.8-2.8c0.4-1.4,0.8-3,1.4-4.4c0.4-1.2,1.2-2.4,1.6-3.6 c0.6-1.4,1.2-2.6,1.8-4c0.8-1.4,1.8-3,2.6-4.6c0.8-1.2,1.4-2.2,2.2-3.4c1.2-1.8,2.4-3.4,3.8-5.2c0.8-1,1.4-1.8,2.2-2.8 c1.6-2,3.2-4,5-6c0.6-0.8,1.4-1.6,2-2.2c2-2.2,4.2-4.4,6.4-6.6c0.6-0.6,1.2-1.2,1.8-1.8c2.4-2.4,5-4.6,7.6-7 c0.2-0.2,0.4-0.4,0.6-0.6l0,0l0.2-0.2l-2-6.4c-26,22.2-45.4,47.4-45.4,68.4c0,11,0,21.8,0,32.8c0,8.8,6.8,12.2,15,7.4l35-20.2 l30.4-17.6L379.71,752.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M429.9,639.21c2-0.6,3.8-1,5.6-1.4c1.6-0.4,3.4-1,5-1.2c1.8-0.4,3.6-0.6,5.2-0.8c1.6-0.2,3.4-0.6,4.8-0.6 s2.6,0.2,3.8,0.2c1.4,0,3,0,4.2,0.2c2.2,0.4,4.2,1.2,5.6,2.4c3,2,4.6,5.6,4.6,11v32.8c0,6.6-5.6,15.8-12,19.4l-57.6,33.2l0,0 l-8.4,4.8v7.2l4.2-2.4l32.8-19l32-18.4c8.2-4.8,15-15.8,15-24.8v-32.8c0-20.6-18.8-23.6-44.4-16.2c0.2,1,0.4,2,0.2,3L429.9,639.21z "
}), React.createElement("path", {
  className: "st2",
  d: "M422.3,645.61l5.6-5.6c0.6-0.2,1.2-0.4,2-0.6c0,0,0,0,0-0.2c0,0,0,0,0.2,0l0.8-3.4c0.2-1,0-2-0.2-3 c-2,0.6-3.8,1-5.8,1.8L422.3,645.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M346.7,686.81c-0.6-2-1.2-4-1.8-6.4c-1.8,1.4-3.4,2.8-5,4.2l2,6.4C343.5,690.01,345.31,688.41,346.7,686.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M422.3,645.61L422.3,645.61l2.6-11.2c0,0,0,0-0.2,0C423.91,638.81,422.9,642.21,422.3,645.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M378.5,689.81v45.8c1,1.4,1.8,2.6,2.8,4l2,2.6l7.6-20.4v-38.2L378.5,689.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M390.91,683.81v-6.6l-1.8,1.8c-1,0.8-2.2,1.6-3.4,1.8l-3.6,0.6l-3.4,1.6v6.8L390.91,683.81z"
}), React.createElement("polygon", {
  className: "st2",
  points: "378.5,681.61 378.5,682.81 382.11,681.21  "
}), React.createElement("path", {
  className: "st2",
  d: "M389.1,754.21c-0.6,0.2-1.2,0.4-1.6,0.4c-0.2,0.2-0.4,0.2-0.4,0.4C387.71,755.01,388.5,755.01,389.1,754.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M387.71,671.41l1.2-1.2c-1.2-1.2-2.6-1.8-4.4-1.8c-3.6,0-6.2,2.8-6.2,6.2v1l1.6-0.2L387.71,671.41z"
}), React.createElement("polygon", {
  className: "st2",
  points: "384.71,674.41 387.71,671.41 380.31,675.21  "
}), React.createElement("polygon", {
  className: "st2",
  points: "378.5,675.41 378.5,676.01 380.31,675.21  "
}), React.createElement("path", {
  className: "st2",
  d: "M389.51,670.61c-0.2-0.2,0-0.4-0.2-0.6l-1.2,1.2L389.51,670.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M389.1,678.81l1.8-1.8v-0.2l-8.8,4.4l3.6-0.6C387.11,680.21,387.9,679.81,389.1,678.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M382.11,681.21l8.8-4.4v-2.4c0-1.4-0.8-2.8-1.6-3.8l-1.4,0.8l-3,3l-4.6,0.8l-1.6,0.8v5.8L382.11,681.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M390.91,721.81l-7.6,20.4l-2-2.6c-1-1.6-1.8-2.6-2.8-4v10.8l0.2,0.2l12.2-7v-0.2 C390.91,739.61,390.91,721.81,390.91,721.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M389.1,754.21c1-1.2,1.8-2.6,1.8-4.2v-3.4l-3.4,2v-0.2l-5.4,3l0,0l-2.4,1.4c1,1.8,2.6,3.2,5,3.2 c0.8,0,1.4-0.6,2.2-0.8c0.2-0.2,0.4-0.2,0.4-0.4C387.9,755.01,388.5,754.41,389.1,754.21z"
}), React.createElement("polygon", {
  className: "st2",
  points: "378.5,746.41 382.3,751.61 387.3,748.61 390.91,739.61  "
}), React.createElement("polygon", {
  className: "st2",
  points: "390.91,739.61 390.91,739.61 390.91,739.21  "
}), React.createElement("path", {
  className: "st2",
  d: "M378.5,746.41v0.2V746.41z"
}), React.createElement("polygon", {
  className: "st2",
  points: "382.3,751.61 379.71,752.81 379.71,753.01  "
}), React.createElement("rect", {
  x: 389.1,
  y: 745.61,
  className: "st2",
  width: 0,
  height: 4
}), React.createElement("polygon", {
  className: "st2",
  points: "390.91,739.61 390.91,739.61 387.3,748.61 390.91,746.61  "
}), React.createElement("path", {
  className: "st2",
  d: "M378.5,746.61v3.4c0,1.2,0.6,2,1.2,3l2.4-1.4L378.5,746.61L378.5,746.61z"
}));

var SvgProfileIcon = function SvgProfileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProfileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Profile_Icon.cdf16dcf.svg";
export { ForwardRef as ReactComponent };